import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-full text-center"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_splide_slide = _resolveComponent("splide-slide")
  const _component_splide = _resolveComponent("splide")

  return ($props.data.length && $data.announcementBarData.length)
    ? (_openBlock(), _createBlock(_component_splide, {
        key: 0,
        class: "announcement-bar--bar",
        options: {
      type: $props.autoSlide ? 'loop' : 'slide',
      pagination: false,
      autoHeight: true,
      drag: false,
      perPage: 1,
      perMove: 1,
      arrows: false,
      autoplay: $props.autoSlide,
      interval: $props.autoSlide && $props.slideInterval,
      speed: '600',
      easing: 'ease',
      destroy: $data.announcementBarData.length > 1 ? false : 'completely',
    }
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.announcementBarData, (bar) => {
            return (_openBlock(), _createBlock(_component_splide_slide, {
              key: bar.text,
              class: "w-full text-14 text-white"
            }, {
              default: _withCtx(() => [
                (bar.text)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (bar.url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: bar.url
                          }, _toDisplayString(bar.text), 9, _hoisted_2))
                        : (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(bar.text), 1))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["options"]))
    : _createCommentVNode("", true)
}